import {
  Autocomplete,
  Button,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";
import Modal from "../ui/Modal";
import FormItem from "../ui/FormItem";
import { createProgram, editProgram, searchCourses } from "../../api";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import {
  Add,
  CloseFullscreen,
  CloseOutlined,
  CloseRounded,
  PlusOne,
} from "@mui/icons-material";
import { Box } from "@mui/system";

const AddProgram = ({ data, refresh, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    numYear: 0,
    eligibility: "",
    degree: "",
    courses: [null],
  });
  const [inputValues, setInputValues] = useState([""]);
  const [courses, setCourses] = useState([]);

  const addCourse = () => {
    let _formData = { ...formData };
    let _courses = _formData.courses;
    console.log(inputValues);
    let _inputValues = [...inputValues, ""];

    _courses.push(null);
    _formData.courses = _courses;
    setFormData(_formData);
    setInputValues(_inputValues);
  };

  const deleteCourse = (id) => {
    let _formData = { ...formData };
    let _courses = _formData.courses;
    let _inputValues = [...inputValues];
    _courses = _courses.filter((val, ind) => {
      return ind !== id;
    });
    _inputValues = _inputValues.filter((val, ind) => {
      return ind !== id;
    });
    _formData.courses = _courses;
    setInputValues(_inputValues);
    setFormData(_formData);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const getCourses = (value) => {
    searchCourses(value)
      .then((res) =>
        setCourses(res.data.rows.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }));
  };

  const handleSubmit = () => {
    setLoading(true);
    const submit = data ? editProgram : createProgram;
    // console.log(formData);
    // console.log(inputValues);
    submit(formData)
      .then((_) => {
        enqueueSnackbar(`Program ${data ? "edited" : "added"}.`, {
          variant: "success",
        });
        refresh();
        props.close();
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (data) {
      setFormData(data);
    } else {
      setFormData({
        name: "",
        code: "",
        numYear: 0,
        eligibility: "",
        degree: "",
        courses: [null],
      });
    }
  }, [data]);

  return (
    <Modal
      {...props}
      title={`${data ? "Edit" : "Add"} Program`}
      actionText={data ? "Edit" : "Add"}
      action={handleSubmit}
      loading={loading}
    >
      <Stack>
        <Stack direction={"row"} spacing={2} alignItems="center">
          <FormItem label="Name of program">
            <TextField
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </FormItem>
          <FormItem label="Program code">
            <TextField
              name="code"
              value={formData.code}
              onChange={handleChange}
            />
          </FormItem>
        </Stack>
        <Stack direction={"row"} spacing={2} alignItems="center">
          <FormItem label="Number of years">
            <TextField
              name="numYear"
              value={formData.numYear}
              onChange={handleChange}
              type="number"
            />
          </FormItem>
          <FormItem label="Degree">
            <Select
              name="degree"
              value={formData.degree}
              onChange={handleChange}
              fullWidth
            >
              <MenuItem value="POLYTECHNIC">POLYTECHNIC</MenuItem>
              <MenuItem value="PHARMACY">PHARMACY</MenuItem>
              <MenuItem value="NURSING">NURSING</MenuItem>
            </Select>
          </FormItem>
        </Stack>
        <Stack direction={"row"} spacing={2} alignItems="center">
          <FormItem label="Eligibility">
            <TextField
              name="eligibility"
              value={formData.eligibility}
              onChange={handleChange}
            />
          </FormItem>
        </Stack>
        <FormItem label="Courses" />
        {formData.courses &&
          formData.courses.map((courseId, index) => {
            return (
              <>
                <Stack
                  key={index}
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  sx={{ my: "8px", width: "100%" }}
                >
                  <Autocomplete
                    value={inputValues[index]}
                    sx={{ width: "100%" }}
                    onChange={(_, newValue) => {
                      let _formData = { ...formData };
                      let _courses = _formData.courses;
                      _courses[index] = newValue?.id;
                      _formData.courses = _courses;
                      setFormData(_formData);
                    }}
                    inputValue={inputValues[index]}
                    onInputChange={(_, newInputValue) => {
                      //console.log(newInputValue);
                      //setInputValue(newInputValue);
                      let _inputValues = [...inputValues];
                      _inputValues[index] = newInputValue;
                      setInputValues(_inputValues);
                      getCourses(newInputValue);
                    }}
                    getOptionLabel={(option) => option.label || option}
                    options={courses}
                    renderInput={(params) => (
                      <TextField sx={{ width: "100%" }} {...params} />
                    )}
                  />
                  <IconButton
                    onClick={() => {
                      deleteCourse(index);
                    }}
                  >
                    <CloseRounded sx={{ color: "red" }} />
                  </IconButton>
                </Stack>
              </>
            );
          })}

        <Box className="row">
          <Button onClick={addCourse} variant="outlined">
            {" "}
            <Add /> Add Course{" "}
          </Button>
        </Box>
      </Stack>
    </Modal>
  );
};

export default AddProgram;
